import React from 'react'
import '../App.css'
import VerticalMenu from '../components/VerticalMenu'
import BackButton from '../components/BackButton'
import HeaderDashboardByVehicle from '../components/HeaderDashboardByVehicle'
import Time from '../components/Time'
import DashboardByVehicleContent from '../components/DashboardByVehicleContent'
import backIcon from '../images/backIcon.svg'
import RefreshButton from '../components/RefreshButton'
import CircularProgress from '@material-ui/core/CircularProgress'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'

class DashboardByVehicle extends React.Component {
  constructor (props) {
    super(props)
    this._isMounted = false
    this.state = {
      loading: true
    }
  }

  componentDidMount () {
    const self = this
    this._isMounted = true
    var token = localStorage.getItem('token')
    if (this._isMounted) {
      getUserInfo(token)
        .then(response => response.json())
        .then(function (data) {
          if (data.error && data.error.code === 401) {
            refreshToken(localStorage.getItem('refresh_token'))
          }
          self.setState({
            loading: false
          })
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    }
  }

  componentWillUnmount () {
    this._isMounted = false
  }

  refreshPage () {
    window.location.reload()
  }

  render () {
    return (
      <div className='App'>
        <table cellSpacing='0' cellPadding='0' style={styles.table}>
          <tbody>
            <tr>
              <td style={styles.colLeft}>
                <VerticalMenu />
              </td>
              <td style={styles.content}>
                <BackButton
                  link='all-report'
                  label='LISTE'
                  img={backIcon}
                  onClick={() => console.log("BACK")}
                />
                <HeaderDashboardByVehicle
                  vehicleNumber={this.props.location.state && this.props.location.state.vehicleNumber ? this.props.location.state.vehicleNumber : localStorage.getItem('vehicleNumber')}
                  trackableLabel={this.props.location.state && this.props.location.state.trackableLabel ? this.props.location.state.trackableLabel : localStorage.getItem('trackableLabel')}
                  trackableName={this.props.location.state && this.props.location.state.trackableName ? this.props.location.state.trackableName : localStorage.getItem('trackableName')}
                  enabled='dashbord'
                />
                <div style={{ marginTop: 6 }}>
                  <RefreshButton
                    onClick={() => this.refreshPage()}
                    label='Rafraichir'
                  />
                </div>
                {this.state.loading ? <CircularProgress
                  style={styles.progressStyle}
                  color='inherit'
                /> : <DashboardByVehicleContent
                  trbImm={this.props.location.state && this.props.location.state.vehicleNumber ? this.props.location.state.vehicleNumber : localStorage.getItem('vehicleNumber')}
                  trackableLabel={this.props.location.state && this.props.location.state.trackableLabel ? this.props.location.state.trackableLabel : localStorage.getItem('trackableLabel')}
                  trackableName={this.props.location.state && this.props.location.state.trackableName ? this.props.location.state.trackableName : localStorage.getItem('trackableName')}
                />
                }
              </td>
              <td style={styles.colRight}>
                <Time />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

const styles = {
  table: {
    width: '100%',
    height: '100vh',
    border: 'none'
  },
  colLeft: {
    backgroundColor: '#020202',
    width: '60px',
    verticalAlign: 'top',
    border: 'none'
  },
  content: {
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  },
  colRight: {
    width: '42px',
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  },
  progressStyle: {
    marginTop: '150px',
    color: '#7ED321'
  }
}

export default DashboardByVehicle
